export default __webpack_public_path__ + "static/PayPerks_Loop-6a3809b5940aab1ff69b8f40e8bfdf7a.mp4";